import styled from '@emotion/styled';
import { SPACER } from 'radiance-ui/lib/constants';

import COLORS from 'styles/constants/colors';

export const ButtonPanelWrapper = styled.div`
  flex-grow: 1;
  margin: 0 1rem 0 1rem;
`;

export const ButtonPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - ${SPACER.medium});

  & button {
    width: 100%;
    border-color: ${COLORS.surfaceBrandLight};
    line-height: 1.25;
  }
`;

// fill the space between the product details and the button,
// so the button aligns to the bottom of the card
export const ButtonSpacer = styled.div`
  flex-grow: 1;
`;
